import { FC, HTMLAttributes } from 'react'
import cn from 'classnames'

export const BottomSliderContainer: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => (
  <div
    data-testid="bottom-slider"
    className={cn('mt-12 mb-8 flex flex-row items-center justify-between gap-4 py-4', className)}
  >
    {children}
  </div>
)
